export default __webpack_public_path__ + "static/media/use_action_cz.48a3e969.png";